import React, { useState } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  Stack,
  Alert,
} from '@mui/material';
import { format, addDays, eachDayOfInterval, differenceInCalendarDays } from 'date-fns';

const studentsList = ['John Doe', 'Jane Smith', 'Alice Johnson', 'Bob Brown'];

const HostelTracker = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(addDays(new Date(), 6)); // Default: 7 days
  const [error, setError] = useState('');
  const [studentData, setStudentData] = useState(
    studentsList.map((name) => ({
      name,
      attendance: {},
    }))
  );

  const handleDateChange = (which, value) => {
    const newDate = new Date(value);
    if (which === 'start') setStartDate(newDate);
    if (which === 'end') setEndDate(newDate);

    const daysDiff = differenceInCalendarDays(
      which === 'end' ? newDate : endDate,
      which === 'start' ? newDate : startDate
    );

    if (daysDiff > 6) {
      setError('Select a range of maximum 7 days.');
    } else {
      setError('');
    }
  };

  const selectedDates =
    !error && startDate && endDate
      ? eachDayOfInterval({ start: startDate, end: endDate })
      : [];

  const toggleValue = (studentIndex, dateKey, field) => {
    setStudentData((prev) => {
      const updated = [...prev];
      const student = updated[studentIndex];
      if (!student.attendance[dateKey]) {
        student.attendance[dateKey] = {
          available: false,
          breakfast: false,
          lunch: false,
          dinner: false,
        };
      }
      student.attendance[dateKey][field] = !student.attendance[dateKey][field];
      return updated;
    });
  };

  return (
    <div style={{ padding: 24 }}>
      <Typography variant="h4" gutterBottom>
        Hostel Weekly Tracker
      </Typography>

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <TextField
          label="Start Date"
          type="date"
          value={format(startDate, 'yyyy-MM-dd')}
          onChange={(e) => handleDateChange('start', e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="End Date"
          type="date"
          value={format(endDate, 'yyyy-MM-dd')}
          onChange={(e) => handleDateChange('end', e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Stack>

      {error && <Alert severity="error">{error}</Alert>}

      {selectedDates.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Student</TableCell>
                {selectedDates.map((date) => (
                  <TableCell key={date} align="center">
                    {format(date, 'EEE dd')}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {studentData.map((student, index) => (
                <TableRow key={index}>
                  <TableCell>{student.name}</TableCell>
                  {selectedDates.map((date) => {
                    const dateKey = format(date, 'yyyy-MM-dd');
                    const data = student.attendance[dateKey] || {
                      available: false,
                      breakfast: false,
                      lunch: false,
                      dinner: false,
                    };
                    return (
                      <TableCell key={dateKey} align="center">
                        <Stack spacing={0.5}>
                          <Button
                            size="small"
                            variant={data.available ? 'contained' : 'outlined'}
                            onClick={() => toggleValue(index, dateKey, 'available')}
                          >
                            A
                          </Button>
                          <Button
                            size="small"
                            variant={data.breakfast ? 'contained' : 'outlined'}
                            onClick={() => toggleValue(index, dateKey, 'breakfast')}
                          >
                            B
                          </Button>
                          <Button
                            size="small"
                            variant={data.lunch ? 'contained' : 'outlined'}
                            onClick={() => toggleValue(index, dateKey, 'lunch')}
                          >
                            L
                          </Button>
                          <Button
                            size="small"
                            variant={data.dinner ? 'contained' : 'outlined'}
                            onClick={() => toggleValue(index, dateKey, 'dinner')}
                          >
                            D
                          </Button>
                        </Stack>
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default HostelTracker;
